import moment from "moment-timezone";
const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // get user Time Zone

export const convertUTCToLocal = (date) => {
  var utcCutoff = moment.utc(date, "YYYYMMDD HH:mm:ss");
  var displayCutoff = utcCutoff.clone().tz(userTimeZone);
  return displayCutoff;
};
